export default __webpack_public_path__ + "static/media/portrait2.7fb02808.jpeg";